import React from "react";
import "../components/scss/HomePage.scss";
import homepageContent from "./homepageContent.json";
import { motion, useViewportScroll, useTransform } from "framer-motion";
import { NavLink } from "react-router-dom";
function HomePage() {
  const { scrollYProgress } = useViewportScroll();
  const headerOpacity = useTransform(scrollYProgress, [0, 0.5], [1, 0]);
  const headerY = useTransform(scrollYProgress, [0, 5], [0, -100]);
  // const middleSectionScale = 1;
  const topEdgeScale = useTransform(scrollYProgress, [0, 0.1], [1, 0.5]);
  const bottomEdgeScale = useTransform(scrollYProgress, [0.9, 1], [0.5, 1]);

  return (
    <div className="container  homepage" style={{ maxWidth: "120rem" }}>
      <motion.header
        style={{
          opacity: headerOpacity,
          y: headerY,
          scale: topEdgeScale,
        }}
      >
        <h1>{homepageContent.header.title}</h1>
        <p>{homepageContent.header.subtitle}</p>
      </motion.header>

      <section className="container-fluid">
        <h2 className="text-center">Key Features</h2>
        <div className="row ">
          {homepageContent.features.map((feature, index) => (
            <div
              key={index}
              className="card mb-5 bg-travel  col-lg-12 "
              style={{ minHeight: "20rem" }}
            >
              <h5 className="card-title">{feature.title}</h5>
              <div className="card-body">
                <figure className="figure  float-end m-5">
                  <img
                    src={feature.images}
                    className="figure-img img-fluid rounded img-thumbnail float-end w-50 ms-5 "
                    alt={feature.title}
                  />
                  <figcaption class="figure-caption text-start fs-4 text-capitalized font-monospace ms-5 mb-5 ">
                    <p style={{ fontSize: "1.6rem" , lineHeight: "3.5rem" , padding: "2rem , 5rem" ,}}>
                    {feature.description}
                    </p>
                  </figcaption>
                </figure>
              </div>
            </div>
          ))}
        </div>
      </section>

      <motion.section className="cta" style={{ scale: bottomEdgeScale }}>
        <h2>{homepageContent.cta.title}</h2>
        <p>{homepageContent.cta.description}</p>
        <NavLink to="/trip_list" className="nav-link">
          <button>Explore Now</button>
        </NavLink>
      </motion.section>
      <motion.footer style={{ scale: bottomEdgeScale }}>
        <p>
          &copy; {new Date().getFullYear()} TravelPlanner. All rights reserved.
        </p>
        <p>
          Contact us: <span>info@travelplanner.com</span>
        </p>
      </motion.footer>
    </div>
  );
}
export default HomePage;
